<template>
  <section class="grid-flex column">
    <!-- filters -->
    <div class="flex-1 flex row w100 middle">
      <div class="flex-1 flex middle">
        <div class="margin-top-s">
          <p>Somente produtos que já possuem venda vão ser listados.</p>
        </div>
      </div>
      <div class="flex-2 w100">
        <div class="flex end row filters-group-holder">
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Atualizar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="forceRefreshData()" class="button secondary">
                <i class="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>
          <div class="flex-1 w100 filter-item">
            <label>Buscar</label>
            <div class="flex w100">
              <input class="input" type="text" v-model="filters.data.search" />
            </div>
          </div>

          <ltk-date-picker
            class="flex-1 w100"
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
      </div>
      </div>
    </div>

    <!-- pagination -->

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 end filters-groupo-holder">
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(product, index) in products" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ product.name | protect }}
                      </p>
                      <small>{{ product.platform }}</small>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div>
                          <p>Receita Bruta</p>
                          <small
                            >{{ product.stats.receita_bruta | money }} ({{
                              product.stats.sales_all | number
                            }})</small
                          >
                        </div>
                        <div>
                          <p>Receita Líquida</p>
                          <small
                            >{{ product.stats.receita_liquida | money }} ({{
                              product.stats.sales | number
                            }})</small
                          >
                        </div>
                        <div>
                          <p>Marketing</p>
                          <small>{{ product.stats.marketing | money }}</small>
                        </div>
                        <div class="profit">
                          <p>Lucro Líquido</p>
                          <small
                            :class="{
                              green: product.stats.profit > 0,
                              red: product.stats.profit < 0,
                            }"
                            >{{ product.stats.profit | money }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                    <router-link
                      :to="{
                        name: 'ProductDetail',
                        params: { product_id: product.id },
                      }"
                    >
                      <div class="button primary">Relatório</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhum produto vendido. Assim que você tiver a
            primeira venda o produto vai aparecer nessa lista de forma
            automática!
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getProducts } from "@/services/product.js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

export default {
  name: "product-list",
  components: { ltkDatePicker },
  data() {
    return {
      loading: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
        },
        list: {},
      },
      products: [],
      totalProduct: 0,
      offset: 20,
      page: 1,
      refreshTime: 60,
      refreshInterval: null,
    };
  },
  mounted() {
    this.getProducts();

    this.refreshInterval = setInterval(this.getProducts, this.refreshTime * 1000)
  },
  destroyed() {
    clearInterval(this.refreshInterval)
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.products && this.products.length === 0;
      return this.totalProduct === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalProduct % this.offset;
      let value = this.totalProduct / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "filters.data.date": {
      deep: true,
      handler() {
        this.products = [];
        this.getProducts();
      },
    },
    "filters.data.search": {
      deep: true,
      handler() {
        this.products = [];
        this.loading = true;
        setTimeout(() => this.getProducts(), 5000);
      },
    },
    "page": {
      handler() {
        this.products = [];
        this.getProducts();
      }
    }
  },
  methods: {
    forceRefreshData() {
      this.getProducts();
    },
    getProducts() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
        search: this.filters.data.search
      };
      getProducts(params)
        .then((result) => {
          this.products = result.products.map((p) => {
            return {
              id: p.id,
              name: p.name,
              platform: p.platform,
              stats: {
                sales: p.stats.sales,
                profit: p.stats.profit,
                receita_liquida: p.stats.receita_liquida,
                receita_bruta: p.stats.receita_bruta,
                sales_all: p.stats.sales_all,
                marketing: p.stats.marketing,
              },
            };
          });
          this.totalProduct = result.total
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar produtos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

@media screen and (max-width: 1024px) {

  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ':'
      }
      small {
        margin-left: 8px;
      }
    }

  }
  .action {
    margin-top: 16px;
  }

}

</style>
